import { Capacitor } from '@capacitor/core';

/**
 * Lightweight offer-submit timing breadcrumbs for diagnosing slow "Submitting…"
 * spins in production (Safari remote console, native WebView inspect, etc.).
 * Console-only — no Firestore writes, no behavior change.
 */
export function createOfferSubmitTimer(source, context = {}) {
  const t0 = performance.now();
  let last = t0;
  const base = {
    source,
    native: Capacitor.isNativePlatform(),
    ...context,
  };

  const log = (phase, extra = {}) => {
    const now = performance.now();
    console.info('[offer-submit]', {
      ...base,
      phase,
      elapsedMs: Math.round(now - t0),
      stepMs: Math.round(now - last),
      ...extra,
    });
    last = now;
  };

  log('start');

  return {
    mark: log,
    fail(err) {
      log('error', { message: err?.message || String(err) });
    },
  };
}
